const generateTransactionId = async () => {
    return String(Math.floor(Math.random() * 90000000000000) + 10000000000000);
};

export default generateTransactionId